/** Hoje no formato `AAAA-MM-DD` local, para comparar com `LocalDate` sem criar `Date` de string. */
export const hojeIso = (agora: Date = new Date()) => {
  const mes = String(agora.getMonth() + 1).padStart(2, '0')
  const dia = String(agora.getDate()).padStart(2, '0')
  return `${agora.getFullYear()}-${mes}-${dia}`
}

/** `LocalDate` já passou (estritamente antes de hoje). */
export const dataVencida = (data?: string | null, agora?: Date) => !!data && data < hojeIso(agora)
